<template>
  <common-panel
    class="new-training-center"
    title="营销活动"
    :isShowPaddingTop="false"
    :ifShowMore="true"
    moreTarget="_blank"
    moreLink="//myseller.haiziwang.com/product-collection-biz/"
  >
    <a-tabs :activeKey='activeKey' @change="change">
      <template v-for="(pItem) in tabPaneList">
        <a-tab-pane :tab="pItem.name" :key='pItem.key'>
          <template v-for="(cItem, cIndex) in productionList">
            <div class="activity-item" :key="cIndex + 'activity'" @click="goToSignUp(cItem)">
              <div class="item-left">
                <span class="name">{{pItem.name}}</span>
                <span class="date">{{momentYD(cItem.activityStart)}}</span>
                <span class="week">{{momentWeek(cItem.activityStart)}}</span>
              </div>
              <div class="item-right">
                <span class="activity-name">{{cItem.name}}</span>
                <span class="join" style="margin-bottom:5px">报名时间：{{momentTime(cItem.joinStart, cItem.joinEnd)}}</span>
                <span class="join">活动时间：{{momentTime(cItem.activityStart, cItem.activityEnd)}}</span>
              </div>
            </div>
          </template>
        </a-tab-pane>
      </template>
    </a-tabs>
    <span class="check-more" v-if="proTotal > 3" @click="goActivityList">查看更多></span>
  </common-panel>
</template>

<script>
import CommonPanel from "@/components/common-panel/index"
import { Tabs } from 'ant-design-vue'
import _ from 'lodash'
import moment from 'moment'
const { TabPane } = Tabs
export default {
  components: {
    CommonPanel,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  data() {
    return {
      activeKey: 2,
      tabPaneList: [
        {name:'拼团',key:2},
        {name:'秒杀',key:1},
        {name:'社群',key:3}
      ],
      week:{
        0:'周日',
        1:'周一',
        2:'周二',
        3:'周三',
        4:'周四',
        5:'周五',
        6:'周六',
      },
      productionList: [],
      proTotal: 0
    }
  },
  created() {
    this.getProductionCollection(this.activeKey)
  },
  methods: {
    // 换算活动开始月日时间
    momentYD(start_time) {
      return moment(start_time).format('MM月DD日')
    },
    // 换算活动开始周
    momentWeek (start_time) {
      return this.week[moment(start_time).day()]
    },
    // 切换面板时调用
    change(activeKey) {
      this.activeKey = activeKey
      this.getProductionCollection(activeKey)
    },
    async getProductionCollection (type) {
      let proRes = await this.$store.dispatch('popHome/queryProductionCollection',{type, page:1, canJoin:0, size:3})
      this.productionList = _.get(proRes, ['data', 'list'])
      this.proTotal = _.get(proRes, ['data', 'count'])
    },
    momentTime (start, end) {
      if (!start || !end) return ''
      return moment(start).format('YYYY.MM.DD HH:mm:ss') + '-' + moment(end).format('YYYY.MM.DD HH:mm:ss')
    },
    // 点击查看更多
    goActivityList () {
      window.open(`//myseller.haiziwang.com/product-collection-biz/activity/${this.activeKey}`)
    },
    // 点击跳转对应的报名位置
    goToSignUp(item) {
      window.open(`//myseller.haiziwang.com/product-collection-biz/activity/${item.type}/${item.id}/detail`)
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-item {
  width: 100%;
  height: 90px;
  background: #f7f7f7;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  .item-left {
    width: 70px;
    height: 70px;
    background: #FFFFFF;
    border: 1px solid #1C7AE5;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: MicrosoftYaHei;
    font-size: 13px;
    color: #333333;
    letter-spacing: 0;
    line-height: 18px;
    margin-right: 10px;
    .name {
      width: 70px;
      height: 26px;
      background: #1C7AE5;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      margin-bottom: 2px;
    }
    .date {
      margin-bottom: 2px;
    }
  }
  .item-right {
    display: flex;
    flex-direction: column;
    font-family: MicrosoftYaHei;
    letter-spacing: 0;
    font-size: 12px;
    color: #666666;
    .activity-name {
      font-size: 14px;
      color: #333333;
      margin-bottom: 7px;
    }
    span {
      white-space: nowrap;
    }
  }
}
.check-more {
  font-family: MicrosoftYaHei;
  font-size: 13px;
  color: #666666;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
